// Pioneiros podem contar até 55 horas por mês de atividades aprovadas
// (LDC, Betel, escolas, socorro). O excedente não é relatado.
export const TETO_CREDITOS_MINUTOS = 55 * 60;
export function limitarCreditos(minutos) {
    return Math.min(Math.max(0, minutos), TETO_CREDITOS_MINUTOS);
}
//# sourceMappingURL=creditos.js.map